// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-task-v2-intro p {
  margin: 0;
}
.fi-task-v2-intro .automated-task-intro {
  line-height: 20px;
}`, "",{"version":3,"sources":["webpack://./Source/app/task-v2/components/fi-task-v2-intro/fi-task-v2-intro.component.scss"],"names":[],"mappings":"AACI;EACI,SAAA;AAAR;AAEI;EACI,iBAAA;AAAR","sourcesContent":[".fi-task-v2-intro {\r\n    p {\r\n        margin: 0;\r\n    }\r\n    .automated-task-intro {\r\n        line-height: 20px;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
